import { lazy, Suspense, useEffect, useState } from 'react';
import { Await } from 'react-router';
import type { CountryLookup } from '@/lib/country-suggestion';

const CountrySuggestionDialog = lazy(() => import('./country-suggestion-dialog'));

export function CountrySuggestion({ lookup }: { lookup: Promise<CountryLookup> }) {
    const [hydrated, setHydrated] = useState(false);
    useEffect(() => setHydrated(true), []);

    // This automatic prompt is requested on arrival. Mount its lazy overlay only
    // after hydration and a supported mismatch; it never occupies document flow.
    if (!hydrated) return null;
    return (
        <Suspense fallback={null}>
            <Await resolve={lookup} errorElement={null}>
                {({ suggestion }: CountryLookup) =>
                    suggestion && (
                        <Suspense fallback={null}>
                            <CountrySuggestionDialog
                                key={`${suggestion.currentCountryCode}-${suggestion.countryCode}`}
                                suggestion={suggestion}
                            />
                        </Suspense>
                    )
                }
            </Await>
        </Suspense>
    );
}
